import { usePage } from '@inertiajs/react';
import { Breadcrumbs } from '@/components/breadcrumbs';
import { SidebarTrigger } from '@/components/ui/sidebar';
import type { BreadcrumbItem as BreadcrumbItemType, User } from '@/types';

export function AppSidebarHeader({
    breadcrumbs = [],
}: {
    breadcrumbs?: BreadcrumbItemType[];
}) {
    const { auth } = usePage<{ auth: { user: User } }>().props;

    return (
        <header className="sticky top-0 z-50 flex h-14 shrink-0 items-center justify-between border-b border-black/[0.05] bg-white/90 px-4 backdrop-blur-md md:px-6 dark:border-white/[0.05] dark:bg-[#0c1410]/90">
            <div className="flex items-center gap-2">
                <SidebarTrigger className="h-8 w-8 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-white/5 dark:hover:text-white/60" />
                <div className="hidden h-4 w-px bg-slate-200 md:block dark:bg-white/10" />
                <div className="hidden md:block">
                    <Breadcrumbs breadcrumbs={breadcrumbs} />
                </div>
            </div>

            <div className="flex items-center gap-2.5">
                <div className="hidden flex-col items-end md:flex">
                    <span className="text-[13px] font-semibold text-slate-700 dark:text-white/80">
                        {auth.user.name}
                    </span>
                    <span className="text-[9px] font-medium tracking-widest text-slate-400 uppercase dark:text-white/30">
                        {auth.user.role === 'admin' ? 'Administrator' : auth.user.role}
                    </span>
                </div>
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-admin-primary text-xs font-bold text-white">
                    {auth.user.name.charAt(0).toUpperCase()}
                </div>
            </div>
        </header>
    );
}
